var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-container"},[_c('DataReady',{attrs:{"id":"content"}},[_c('UsersDetail',{attrs:{"userId":_vm.$store.getters.currentUserId}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }